import {Component} from '@angular/core';

@Component({
    selector: 'app-enrollment',
    templateUrl: './enrollment.component.html',
    styleUrls: ['./enrollment.component.scss'],
    standalone: false
})
export class EnrollmentComponent {
}
